import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ReportsTurnsService } from 'src/app/services/turns-services/reports-turns-service/reports-turns.service';
import { tap } from 'rxjs/internal/operators/tap';
import { EMPTY, Subscription } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { DashboardService } from 'src/app/services/dashboard-services/dashboard.service';
import { AudienceWifiService } from 'src/app/services/audience-services/audience-wifi-service/audience-wifi.service';

@Component({
  selector: 'app-audience-wifi',
  templateUrl: './audience-wifi.component.html',
  styleUrls: ['./audience-wifi.component.scss']
})
export class AudienceWifiComponent implements OnInit {

  centers;
  wifiStats;
  selectedCenters = [];
  from;
  to;

  colors = [
    '#3bafda',
    '#ed5565',
    '#fcbb42',
    '#37bc9b',
    '#967adc',
    '#d770ad',
    '#ff9d00',
    '#75560d',
    '#ffe4b5',
    '#eeeeee',
    '#6d7182',
  ];

  getWifiSubscription: Subscription;
  dashboardServiceSubscription: Subscription;

  constructor(
    private headerBreadcrumbService: HeaderBreadcrumbService,
    private userStorageService: UserStorageService,
    private audienceWifiService: AudienceWifiService,
    private dashboardService: DashboardService,
    private snackbarService: SnackBarService) {
      this.centers = this.userStorageService.getCenterList();
    }

  ngOnInit() {
    this.setBreadcrumb();
    if (this.dashboardServiceSubscription) { this.dashboardServiceSubscription.unsubscribe(); }
    this.dashboardServiceSubscription = this.dashboardService.listenReloadStatistics().pipe(
      tap(o => this.selectedCenters = o['centers']),
      tap(o => this.from = o['from'].valueOf()),
      tap(o => this.to = o['to'].valueOf()),
      tap(o => this.loadData())
    ).subscribe();
  }

  private loadData() {
    this.wifiStats = null;
    this.getWifiStats();
  }

  private getWifiStats() {
    const centerInternalIdList = this.selectedCenters.map( center => center.InternalId );
    this.getWifiSubscription = this.audienceWifiService.getWifiStats(
      this.from,
      this.to,
      centerInternalIdList
    ).pipe(
      tap(o => this.wifiStats = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-th', 'breadcrumb-title.audience wifi'));
  }

}
